
import React from 'react';
import { BOOKING_TYPE } from '../../../constants';

/**
 * @module Modals/BulkBookUnbookModal/ConfirmStep
 */
/**
 * @typedef {object} props
 * @property {object} dateTime
 * @property {Array} selectedCompetitions
 * @property {string} pendingBookingType
 * @property {string} timezone
 * @property {Function} backToFilter
 * @property {Function} confirmAction
 */

/**
 * @param {props} props
 * @returns {view}
 */
const ConfirmStep = ({
  dateTime,
  selectedCompetitions,
  pendingBookingType,
  timezone,
  backToFilter,
  confirmAction,
}) => {
  const actionLabel = BOOKING_TYPE[pendingBookingType]?.toLowerCase();
  const isBook = pendingBookingType === BOOKING_TYPE.BOOK;
  const hasToDateTime = Boolean(dateTime.toDate && dateTime.toTime);
  const competitionLabels = selectedCompetitions.length > 0
    ? selectedCompetitions.map((competition) => competition.name).join(', ')
    : 'All competitions';

  return (
    <>
      <div className="dialog__content">
        <div className="dialog__info text-center">
          <p>
            <strong>
              {!isBook && hasToDateTime
                ? `Are you sure you want to ${actionLabel} all matches between `
                : `Are you sure you want to ${actionLabel} all matches from `}
              {dateTime.fromDate}
              {' '}
              {dateTime.fromTime}
              {!isBook && hasToDateTime && (
                <>
                  {' and '}
                  {dateTime.toDate}
                  {' '}
                  {dateTime.toTime}
                </>
              )}
              {timezone && ` (${timezone})`}
              {' for '}
              {competitionLabels}
              ?
            </strong>
          </p>
        </div>
      </div>
      <div className="dialog__btn-wrap">
        <button
          id="cancel_BulkBookUnbookModal"
          type="button"
          className="btn btn-secondary"
          onClick={backToFilter}
        >
          Cancel
        </button>
        {' '}
        <button
          id="confirm_BulkBookUnbookModal"
          type="button"
          className="btn btn-primary m-l-10"
          onClick={confirmAction}
        >
          Confirm
        </button>
      </div>
    </>
  );
};

export default ConfirmStep;
